import { render, staticRenderFns } from "./LocationDetailsContent.vue?vue&type=template&id=d0107a1e"
import script from "./LocationDetailsContent.vue?vue&type=script&lang=ts"
export * from "./LocationDetailsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports